import { Component, h, Host, Prop } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  tag: 'anchor-notification-badge',
  styleUrl: 'notification-badge.scss',
  shadow: true,
})

export class NotificationBadge {
  /**
   *  Give this instance of notification-badge a custom ID, default generated by uuidV4.
   */
  @Prop() uuid?: string = uuidv4();
  
  /**
   * Variant dictates the state of the notification badge
   */
 @Prop({ reflect: true }) variant?: 'default' | 'error' | 'info' | 'warning ' | 'success' | 'neutral' = 'default';

  /**
   * Number of notifications
   */
 @Prop({ reflect: true }) notifications: number;

  render() {
    return (
      <Host>
        <div class={{
          'badge': true,
          [this.variant]: true,
        }}>
          {this.notifications}
        </div>
      </Host>
    );
  }
}
